import React, { useEffect, useState } from "react";
import { useQuery } from "@supabase-cache-helpers/postgrest-react-query";
import { getVenues } from "../../api/get-venues";
import getSupabaseBrowserClient from "../../hooks/use-supabase-browser";
import * as dayjs from "dayjs";
import getVenueStats from "../../api/stats/get-venue-stats";
import { useQueries } from "@tanstack/react-query";
import { Chart } from "react-google-charts";

const stats = {
  parking_count: { title: "Parkings count", label: "Count" },
  total_tip_amount: { title: "Tip amount", label: "Amount" },
  average_parking_time: { title: "Avg Parking time", label: "Minutes" },
  average_transition_time: { title: "Avg Delivery time", label: "Minutes" },
};

export default () => {
  const supabase = getSupabaseBrowserClient();

  const { data: venues = [] } = useQuery(getVenues(supabase));
  const [selectedVenue, setSelectedVenue] = useState<string | null>(null);
  const [fromDate, setFromDate] = useState<dayjs.Dayjs>(
    dayjs().subtract(4, "weeks")
  );
  const [toDate, setToDate] = useState<dayjs.Dayjs>(dayjs());
  const [noStatsAvailable, setNoStatsAvailable] = useState(false);
  const [loadingStats, setLoadingStats] = useState(false);
  const statsQueries = useQueries({
    queries: Object.keys(stats).map((sk) => {
      return {
        queryKey: [sk, { selectedVenue, fromDate, toDate }],
        queryFn: getVenueStats,
        enabled: !!selectedVenue && !!fromDate && !!toDate,
      };
    }),
  });
  useEffect(() => {
    if (!selectedVenue) return;
    const noStats = statsQueries.every((query) => !query.data);
    setNoStatsAvailable(noStats);

    const loading = statsQueries.some((query) => query.isLoading);
    setLoadingStats(loading);
  }, [statsQueries]);

  return (
    <>
      <section className="card grow bg-base-100 shadow-sm ">
        <div className="card-body">
          <div className="flex items-center gap-2 justify-between	">
            <div className="form-control grow max-w-lg">
              {venues && (
                <select
                  className="select select-bordered w-full"
                  onChange={(event) => setSelectedVenue(event.target.value)}
                >
                  <option key={"unassign"} value={""}>
                    Select a venue
                  </option>
                  {venues.map((venue) => (
                    <option key={venue.id} value={venue.id}>
                      {venue.name}
                    </option>
                  ))}
                </select>
              )}
            </div>
            <div className="form-control">
              <div className="flex items-center gap-2">
                From:
                <input
                  type="date"
                  placeholder="From"
                  className="input input-bordered w-full max-w-xs"
                  value={fromDate.format("YYYY-MM-DD")}
                  onChange={(event) => setFromDate(dayjs(event.target.value))}
                />
                To:
                <input
                  type="date"
                  placeholder="To"
                  className="input input-bordered w-full max-w-xs"
                  value={toDate.format("YYYY-MM-DD")}
                  onChange={(event) => setToDate(dayjs(event.target.value))}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {loadingStats && (
        <span className="loading loading-dots loading-lg"></span>
      )}
      {!loadingStats && noStatsAvailable && (
        <div className="text-center text-2xl">
          There are no stats available for the selected venue
        </div>
      )}

      <div className="grid grid-cols-12 gap-12 mt-4 w-full">
        {Object.keys(stats).map((stat, idx) => {
          if (!statsQueries[idx].data) return <></>;
          return (
            <section className="col-span-6 card grow bg-base-100 shadow-sm ">
              <div className="card-body">
                <div className="card-title">{stats[stat].title}</div>
                <Chart
                  chartType="Bar"
                  options={{
                    backgroundColor: "#FF0000",
                  }}
                  data={[["Day", stats[stat].label]].concat(
                    statsQueries[idx].data
                      .map((stat) => [
                        dayjs(stat.date).format("YYYY-MM-DD"),
                        parseInt(stat.value),
                      ])
                      .sort((a, b) => {
                        return dayjs(a[0]).isBefore(dayjs(b[0])) ? -1 : 1;
                      })
                  )}
                  width="100%"
                  height="400px"
                />
              </div>
            </section>
          );
        })}
      </div>
    </>
  );
};
